import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const DASHBOARD = '/modulesHome/accountingConciliation/conciliacao-contabil';

/**
 * "Voltar" que segue o fluxo de navegação (histórico) em vez de pular sempre
 * para o dashboard do módulo. Se a página foi aberta direto (sem histórico
 * interno — `location.key === 'default'`), cai no fallback informado.
 */
export function useVoltar(fallback: string = DASHBOARD) {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(() => {
    if (location.key !== 'default') navigate(-1);
    else navigate(fallback);
  }, [navigate, location.key, fallback]);
}
